import React from 'react'
import { Route, Routes } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import {ShopList, ShopItem, ShopSearch, ShopColorSearch, ShopDiscount} from './shopdetail/index';
import ShopItemAll from './shopdetail/ShopItemAll';


const useStyles = makeStyles((theme)=>({
  routerItm:{
    margin: 5,
    
  }
}));

const ShopMain = () => {
    const theme = useTheme();
    const classes = useStyles(theme);

  return (
    <div>
        <Routes>
            <Route exact path="ShopList" element={<ShopList />} />
            <Route exact path="ShopItem" element={<ShopItem />} />
            <Route exact path="ShopItemAll" element={<ShopItemAll />} />
            <Route exact path="ShopSearch" element={<ShopSearch />} />
            <Route exact path="ShopColorSearch" element={<ShopColorSearch />} />
            <Route exact path="ShopDiscount" element={<ShopDiscount />} />
        </Routes>
    </div>
  )
}

export default ShopMain
